/** Shared by the region, range and sort chips so the selector row reads as one set. */
export const CONTROL_CHIP_CLASS =
  'inline-flex items-center gap-1 whitespace-nowrap rounded-full border border-border px-2.5 py-1 text-xs font-medium text-foreground hover:bg-accent cursor-pointer'
